export const mapChildren = (mapper) => (children) => {
    if (children === null || children === undefined) {
        return children;
    }
    return Array.isArray(children) ? children.map(mapper) : mapper(children, 0);
};
//# sourceMappingURL=mapChildren.js.map